import React from "react";
import { Plus, Trash2, Link as LinkIcon } from "lucide-react";

/**
 * Repeatable "Talks & Publications" rows: a title plus an optional link.
 * Stored as a list of {title, link}.
 */
export default function PublicationsEditor({ value = [], onChange, className = "" }) {
    const list = Array.isArray(value) ? value : [];

    const update = (idx, field, val) => {
        onChange(list.map((item, i) => (i === idx ? { ...item, [field]: val } : item)));
    };

    const normalizeLink = (idx) => {
        const link = (list[idx]?.link || "").trim();
        if (link && !/^https?:\/\//i.test(link)) {
            update(idx, "link", `https://${link}`);
        }
    };

    const addRow = () => onChange([...list, { title: "", link: "" }]);
    const removeRow = (idx) => onChange(list.filter((_, i) => i !== idx));

    return (
        <div className={`space-y-2.5 ${className}`}>
            {list.map((item, idx) => (
                <div
                    key={idx}
                    className="flex flex-col sm:flex-row gap-2 sm:items-center p-2.5 border border-secondary-200 rounded-lg bg-secondary-50/50"
                >
                    <input
                        type="text"
                        value={item.title || ""}
                        onChange={(e) => update(idx, "title", e.target.value)}
                        placeholder="e.g. Advances in Breast Conservation Surgery, 2022"
                        className="flex-1 w-full border border-secondary-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-primary-300"
                    />
                    <div className="flex items-center gap-1.5 w-full sm:w-56 flex-shrink-0">
                        <LinkIcon className="w-3.5 h-3.5 text-secondary-400 flex-shrink-0" />
                        <input
                            type="text"
                            value={item.link || ""}
                            onChange={(e) => update(idx, "link", e.target.value)}
                            onBlur={() => normalizeLink(idx)}
                            placeholder="Link (optional)"
                            className="flex-1 w-full border border-secondary-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-primary-300"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={() => removeRow(idx)}
                        className="self-end sm:self-center p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors flex-shrink-0"
                        title="Remove"
                    >
                        <Trash2 className="w-4 h-4" />
                    </button>
                </div>
            ))}
            <button
                type="button"
                onClick={addRow}
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-700 bg-primary-50 hover:bg-primary-100 border border-primary-200 rounded-lg px-3 py-2 transition-colors"
            >
                <Plus className="w-3.5 h-3.5" />
                Add Talk / Publication
            </button>
        </div>
    );
}
